module.exports = __webpack_public_path__ + "static/4bagrHeader-d89f292c186247d68ab78a8faaa69ddc.png";